import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Header />
      <div className="container-page py-24 text-center">
        <div className="overline text-[#B4533C]">404</div>
        <h1 className="font-serif text-6xl md:text-8xl tracking-tight mt-4">Off the map.</h1>
        <p className="mt-4 text-[#4A4742]">That page doesn't exist, or it's been retired. Try the homepage.</p>
        <Link to="/" className="inline-block mt-8 border border-[#1B3B36] text-[#1B3B36] px-6 py-3 hover:bg-[#1B3B36] hover:text-white">← Home</Link>
      </div>
      <Footer />
    </div>
  );
}
